export default __webpack_public_path__ + "afa9d8b2f12c20cfe52ef5a83bd5ae0f.png";